import * as React from 'react';
import { RouteComponentProps, Prompt } from 'react-router-dom';
import { fetchApi, JsonResponse } from '../../services/api';
import { IDName } from '../Accounts/Payments';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import LoadingButton from '../LoadingButton';
const DocumentTitle = require('react-document-title');

type TeacherProps = RouteComponentProps<{
    teacherId: string
}>

type State = {
    isLoading: boolean;
    isDirty: boolean;
    Validation: boolean;

    schools: IDName[];
    teacher: TeacherData|undefined;
}

type TeacherData = {
    TeacherId: number;
    FirstName: string;
    LastName: string;
    SchoolId?: number;
}

class Teacher extends React.Component<TeacherProps, State> {
    constructor(props: TeacherProps) {
        super(props);

        this.state = {
            isLoading: true,
            isDirty: false,
            Validation: false,
            teacher: undefined,
            schools: []
        }

        this.save = this.save.bind(this);
    }

    public componentWillMount() {
        // This method runs when the component is first added to the page
        let teacherId = parseInt(this.props.match.params.teacherId) || 0;
        this.requestTeacher(teacherId);
    }

    public componentWillReceiveProps(nextProps: TeacherProps) {
        // This method runs when incoming props (e.g., route params) change
        let teacherId = parseInt(nextProps.match.params.teacherId) || 0;

        if (this.state.teacher && this.state.teacher.TeacherId != teacherId) {
            this.requestTeacher(teacherId);
        }
    }

    public render() {
        return <React.Fragment>
            {this.state.teacher &&
                <div className="k-form">
                    <DocumentTitle title={(!this.state.teacher.FirstName && !this.state.teacher.LastName) ? "New Teacher" : this.state.teacher.FirstName + " " + this.state.teacher.LastName} />
                    <Prompt when={this.state.isDirty} message="Unsaved changes will be lost, are you sure?" />
                    {this.state.isLoading && <div className="k-loading-image"></div>}
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text">First and Last Name<div style={{ color: '#dc3545' }}>*</div></span>
                        </div>
                        <input
                            className="form-control"
                            type="text"
                            name={`FirstName`}
                            placeholder="First Name"
                            value={this.state.teacher.FirstName}
                            onChange={(e) => this.updateTeacherState({ FirstName: e.target.value })}
                        />
                        <input
                            className="form-control"
                            type="text"
                            name={`LastName`}
                            placeholder="Last Name"
                            value={this.state.teacher.LastName}
                            onChange={(e) => this.updateTeacherState({ LastName: e.target.value })}
                        />
                    </div>
                    <br />
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text">School</span>
                        </div>
                        <DropDownList
                            textField="Name"
                            className="form-control"
                            data={this.state.schools}
                            value={this.state.schools.find(x => x.ID == this.state.teacher.SchoolId)}
                            onChange={(e) => this.updateTeacherState({ SchoolId: e.target.value.ID })}
                        />
                    </div>
                    {this.state.Validation && !this.state.teacher.FirstName && !this.state.teacher.LastName && <p className="error-msg">First and Last Name are Required</p>}
                    {this.state.Validation && !this.state.teacher.FirstName && this.state.teacher.LastName && <p className="error-msg">First Name is Required</p>}
                    {this.state.Validation && this.state.teacher.FirstName && !this.state.teacher.LastName && <p className="error-msg">Last Name is Required</p>}
                    {this.state.Validation && this.state.teacher.FirstName && this.state.teacher.LastName && <br/> || !this.state.Validation && <br/>}
                    <br />
                    <div className="text-right">
                        <LoadingButton 
                            onClick={this.save}
                            disabled={!this.state.isDirty}
                            isLoading={this.state.isLoading}
                            isLoadingText="Saving..."
                            className="btn btn-primary"
                        >
                            {this.state.teacher.TeacherId === 0 ? 'Create' : 'Save'}
                        </LoadingButton>
                    </div>
                </div>
            }
        </React.Fragment>;
    }

    private updateTeacherState(value: Partial<TeacherData>) {
        const teacher = Object.assign({}, this.state.teacher, value);
        this.setState({ teacher, isDirty: true });
    }

    private requestTeacher(teacherId: number) {
        this.setState({ isLoading: true });
        fetchApi(`api/Teacher/Get/${teacherId}`)
            .then((response: { Schools: IDName[], Teacher: TeacherData }) => {
                this.setState({ isLoading: false, isDirty: false, teacher: response.Teacher, schools: [{ ID: null, Name: 'None' }, ...response.Schools] });
            });
    }

    private save() {
        if (!this.state.teacher.FirstName) {
            alert("Please enter a First name!");
            return;
        }

        if (!this.state.teacher.LastName) {
            alert("Please enter a Last name!");
            return;
        }

        this.setState({ Validation: true }, () => {
            if (this.state.teacher && document.getElementsByClassName("error-msg").length === 0) {
                this.setState({ isLoading: true });
                if (this.state.teacher.TeacherId > 0) {
                    fetchApi(`api/Teacher/Save/${this.state.teacher.TeacherId}`, this.state.teacher, 'POST')
                        .then((response: JsonResponse) => {
                            if (response.Success) {
                                this.setState({ isLoading: false, isDirty: false });
                            } else {
                                this.setState({ isLoading: false });
                                alert(response.ErrorMessage);
                            }
                        });
                } else {
                    fetchApi(`api/Teacher/Create/`, this.state.teacher, 'POST')
                        .then((response: JsonResponse) => {
                            if (response.Success) {
                                this.setState({ isLoading: false, isDirty: false });
                                
                                this.props.history.push("/teachers");
                            } else {
                                this.setState({ isLoading: false });
                                alert(response.ErrorMessage);
                            }
                        });
                }
            }
        });
    }
}

export default Teacher;
